'use client';

import { cn } from '@/lib/utils';

const Video = ({
    src,
    posterSrc,
    className,
}: {
    src: string;
    posterSrc: string;
    className?: string;
}) => {
    return (
        <video
            width="1280"
            height="720"
            preload="none"
            loop
            muted
            autoPlay
            poster={posterSrc}
            playsInline
            className={cn('h-full w-full object-cover', className)}
        >
            <source src={src} type="video/webm" />
            Your browser does not support the video tag.
        </video>
    );
};

export default Video;
